<template>
    <div>
        <v-file-input
            class="mt-6 mb-6"
              required
              counter
              show-size
              :rules="[rules.resizeImag]"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-paperclip"
              label="Upload"
              @change="selectImgCoverUpdate"
              v-model="filesUpdateImgCover"
            ></v-file-input>
    </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment'
import 'moment/locale/th' // momentภาษาไทย
export default {
  name: 'BelinkSlipokPaymentUploadSlipOK',

  data () {
    return {
      rules: {
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!'
      },
      formUpload: {},
      filesUpdateImgCover: null

    }
  },

  mounted () {

  },
  methods: {
    async onCheckSlipForIMG (shopId, depositAmount, languageSelect, bookNo) {
      console.log('bookNo', bookNo)

      const dataChkStatusSlipok = new FormData()
      dataChkStatusSlipok.append('shopId', shopId)
      dataChkStatusSlipok.append('amount', depositAmount)
      dataChkStatusSlipok.append('bookNo', bookNo)
      dataChkStatusSlipok.append('files', this.filesUpdateImgCover)

      try {
        const res = await axios.post(
          this.DNS_IP + '/check_status_switchSlipOK',
          dataChkStatusSlipok,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )

        if (res.data.code) {
          console.log('res.data.code', res.data.code)
          console.log('res.data', res.data)

          let message = ''
          let textThai = ''
          switch (res.data.code) {
            case 1012:
              textThai = `สลิปนี้ถูกใช้ไปแล้ว เมื่อ ${this.formatDateWithMoment(res.data.message, true)}\nหากต้องการตรวจสอบ โปรดติดต่อร้านค้า`
              message = `This slip was used on ${this.formatDateWithMoment(res.data.message, false)}`
              break

            case 1013:
              textThai = 'ยอดที่ต้องโอนกับยอดในสลิปไม่ตรงกัน'
              message = 'The amount to be transferred does not match the amount on the slip.'
              break

            case 1014:
              textThai = 'บัญชีผู้รับไม่ตรงกับบัญชีหลักของร้าน กรุณาติดต่อร้านเพื่อยืนยันการชำระ'
              message = "The recipient's account does not match the store's main account. Please contact the store to confirm the payment."
              break

            case 1010:
              textThai = res.data.message
              message = 'Please wait for the slip to be verified. Please upload again.'
              break

            default:
              textThai = 'อัพโหลดไม่สำเร็จ โปรดติดต่อร้านค้า'
              message = 'Failed to upload image. Please contact the seller.'
          }

          this.formUpload.depositImge = ''

          await this.$swal({
            title: languageSelect === '0' ? 'ไม่สำเร็จ' : 'Failed',
            text: languageSelect === '0' ? textThai : message,
            type: 'error',
            confirmButtonText: languageSelect === '0' ? 'ตกลง' : 'OK',
            showConfirmButton: true
          })
          this.filesUpdateImgCover = null

          return false
        } else {
          return true
        }
      } catch (error) {
        console.error('Error in onCheckSlipForIMG:', error)
        // เพิ่มแจ้งเตือนติดต่อร้านค้า
        return false
      }
    },
    selectImgCoverUpdate () {
      if (this.filesUpdateImgCover) {
        this.formUpload.depositImge = URL.createObjectURL(
          this.filesUpdateImgCover
        )
      } else {
        this.formUpload.depositImge = ''
      }
      this.$emit('upload-image', this.filesUpdateImgCover, this.formUpload.depositImge)
    },
    formatDateWithMoment (text, isThai) {
      console.log('text', text.transTimestamp, text)

      const locale = isThai ? 'th' : 'en'
      moment.locale(locale)

      const format = isThai
        ? 'dddd ที่ D MMMM YYYY เวลา HH:mm น.'
        : 'dddd, D MMMM YYYY at h:mm A'

      const engDate = text.split('เมื่อ ')[1]
      console.log('engDate', engDate)
      const thaiDate = text.split('เมื่อ ')[1]

      if (thaiDate) {
        return moment(new Date(thaiDate)).format(format) // แปลงวันที่จาก thaiDate
      } else if (engDate) {
        return moment(new Date(engDate)).format(format) // แปลงวันที่จาก engDate
      } else {
        return text
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Extensions/PaymentUploadSlipOK.vue